/* src/app/pocsag/pocsag.component.css */
a {
  text-decoration: none;
}
#container {
  top: 50px;
  float: left;
  position: relative;
  left: 50%;
  z-index: 99;
}
#centered {
  color: white;
  font-size: larger;
  background-color: red;
  float: left;
  position: relative;
  left: -50%;
  border: 1px solid silver;
  padding: 15px;
  border-radius: 15px;
}
.panel_pocsag {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px 5px 5px 5px;
}
.panel-heading-right {
  padding: 3px;
  word-wrap: break-word;
  width: auto;
  float: right;
  font-size: 10px;
}
.panel-heading-left {
  padding: 3px;
  word-wrap: break-word;
  margin-right: auto;
  font-size: 10px;
}
.schriftgross {
  font-size: x-large;
}
.gesamt-0,
.eintrag-0 {
  color: #000000;
  background-color: #d2d2d2;
}
.gesamt-0 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-1,
.eintrag-1 {
  color: #ffffff;
  background-color: #f23a3c;
}
.gesamt-1 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #ffd1d5;
}
.gesamt-2,
.eintrag-2 {
  color: #000000;
  background-color: #fcf573;
}
.gesamt-2 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #272727;
}
.gesamt-3,
.eintrag-3 {
  color: #000000;
  background-color: #3bd2bf;
}
.gesamt-3 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #272727;
}
.gesamt-4,
.eintrag-4 {
  color: #000000;
  background-color: #fcab13;
}
.gesamt-4 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #272727;
}
.gesamt-5,
.eintrag-5 {
  color: #ffffff;
  background-color: #f2606a;
}
.gesamt-5 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #ffd1d5;
}
.gesamt-6,
.eintrag-6 {
  color: #fff;
  background-color: #337ab7;
}
.gesamt-6 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #fff;
}
.gesamt-8,
.eintrag-8 {
  color: #000000;
  background-color: #f2fc53;
}
.gesamt-8 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #272727;
}
.gesamt-7,
.eintrag-7 {
  color: #000000;
  background-color: #fea5f7;
}
.gesamt-7 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-9,
.eintrag-9 {
  color: #000000;
  background-color: #f70079;
}
.gesamt-9 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-10,
.eintrag-10 {
  color: #000000;
  background-color: #3c763d;
}
.gesamt-10 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-11,
.eintrag-11 {
  color: #000000;
  background-color: #dd863d;
}
.gesamt11 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-12,
.eintrag-12 {
  color: #000000;
  background-color: #dd863d;
}
.gesamt12 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-13,
.eintrag-13 {
  color: #000000;
  background-color: #dd863d;
}
.gesamt13 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-14,
.eintrag-14 {
  color: #000000;
  background-color: #d2a39c;
}
.gesamt-14 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-15,
.eintrag-15 {
  color: #000000;
  background-color: #d25457;
}
.gesamt-15 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-16,
.eintrag-16 {
  color: #000000;
  background-color: #fe00c3;
}
.gesamt-16 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
.gesamt-17,
.eintrag-17 {
  color: #000000;
  background-color: #ffffff;
}
.gesamt-17 > .footer {
  padding: 3px;
  word-wrap: break-word;
  border-top: 1px solid #242424;
}
/*# sourceMappingURL=pocsag.component-2YHMCPSR.css.map */
